import AppLayout from "@/layouts/AppLayout";

export default function ModeRedirect() {
  return <AppLayout />;
}
